// Single source of truth for all site content.
// Editable placeholders — replace with real details as needed.

export const SITE = {
  name: "Advocate Samikshaa K",
  title: "Real Estate Lawyer",
  location: "Bengaluru, India",
  tagline: "Practical Legal Solutions. Trusted Advice. Complete Protection.",
  email: "contact@samikshaak.com",
  phone: "+91 79876 36117",
  address: "Bengaluru, Karnataka, India",
  linkedin: "https://www.linkedin.com/in/samiksha-kandya-88652563/",
  images: {
    portrait: "/images/samiksha-portrait.jpg",
    architecture:
      "https://images.pexels.com/photos/18800734/pexels-photo-18800734.jpeg?auto=compress&cs=tinysrgb&w=1600",
    documents:
      "https://images.pexels.com/photos/4792291/pexels-photo-4792291.jpeg?auto=compress&cs=tinysrgb&w=1600",
    skyline:
      "https://images.unsplash.com/photo-1627306036351-036986f292a9?auto=format&fit=crop&w=1600&q=80",
  },
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/experience", label: "Experience" },
  { to: "/publications", label: "Publications" },
  { to: "/contact", label: "Contact" },
];

export const HIGHLIGHTS = [
  { label: "6+ Years Experience", meta: "Practice" },
  { label: "Real Estate Specialist", meta: "Focus" },
  { label: "Contract Drafting & Review", meta: "Documentation" },
  { label: "Due Diligence Expert", meta: "Verification" },
  { label: "Technology Law Experience", meta: "Advisory" },
  { label: "Litigation & Court Matters", meta: "Support" },
];

export const SERVICES = [
  {
    id: "real-estate",
    title: "Real Estate Consultancy",
    summary:
      "End-to-end advisory across property transactions, verification, and registration for individuals and developers.",
    items: [
      "Property Transactions",
      "Property Verification",
      "Legal Opinions",
      "Registration Guidance",
      "Land Documentation",
      "Title Verification",
    ],
  },
  {
    id: "due-diligence",
    title: "Due Diligence",
    summary:
      "Rigorous title investigations and risk assessments so you commit capital only when the ground is legally clear.",
    items: [
      "Title Investigation",
      "Ownership Verification",
      "Encumbrance Review",
      "Property Risk Assessment",
      "Legal Compliance",
    ],
  },
  {
    id: "contract-drafting",
    title: "Contract Drafting",
    summary:
      "Precise, negotiation-ready drafting across real estate, corporate, and technology contracts.",
    items: [
      "Sale Deeds",
      "Gift Deeds",
      "Lease Agreements",
      "MOUs",
      "Power of Attorney",
      "Franchise Agreements",
      "Employment Agreements",
      "NDA",
      "SaaS Agreements",
      "API Agreements",
      "EULA",
      "Privacy Policies",
      "Terms of Service",
      "Commercial Agreements",
    ],
  },
  {
    id: "contract-review",
    title: "Contract Review",
    summary:
      "Line-by-line review of live contracts to surface risk, ambiguity, and commercial exposure before you sign.",
    items: [
      "Commercial Contracts",
      "Real Estate Agreements",
      "Vendor Agreements",
      "Employment Contracts",
      "Technology Contracts",
      "Risk Identification",
      "Compliance Review",
    ],
  },
  {
    id: "legal-advisory",
    title: "Legal Advisory",
    summary:
      "Considered legal counsel that fits the business context — for founders, buyers, and established organisations.",
    items: [
      "Individuals",
      "Businesses",
      "Real Estate Developers",
      "Property Buyers",
      "Startups",
      "Companies",
    ],
  },
  {
    id: "litigation",
    title: "Litigation Support",
    summary:
      "Documentation, drafting, and civil-side support for property disputes and related court matters.",
    items: [
      "Court Documentation",
      "Petition Drafting",
      "Civil Matters",
      "Real Estate Litigation Support",
    ],
  },
];

export const EXPERIENCE = [
  {
    org: "Sri Sumeru Realty Pvt. Ltd.",
    role: "Real Estate In-House Lawyer",
    period: "2021 — Present",
    points: [
      "Land Due Diligence",
      "Registration Documentation",
      "Court Matters",
      "Contract Drafting",
      "Negotiations",
      "Sale Deeds, MOUs, Power of Attorney",
      "Compliance",
    ],
  },
  {
    org: "Sumeru Digital Solutions",
    role: "Technology Lawyer",
    period: "2023",
    points: [
      "SaaS Agreements",
      "API Agreements",
      "NDAs",
      "Privacy Policy & Cookie Policy",
      "Terms of Service",
      "EULA",
    ],
  },
  {
    org: "Sri Sri Rural Development Program",
    role: "In-House Lawyer",
    period: "2020",
    points: [
      "Contracts with Bosch and Schneider Electric",
      "Karnataka Jail Manual amendments",
      "Prison reform initiatives",
      "NGO collaborations",
    ],
  },
  {
    org: "Freelance Legal Practice",
    role: "Independent Counsel",
    period: "2019",
    points: [
      "Franchise Agreements",
      "Sale Deeds & Gift Deeds",
      "International clients (Canada, UK, USA)",
    ],
  },
  {
    org: "Choudhary Law Associates",
    role: "Junior Counsel",
    period: "2017 — 2018",
    points: [
      "Criminal Law",
      "Civil Law",
      "Bail Applications",
      "National Green Tribunal",
      "Consumer Forum",
      "Real Estate Documentation",
    ],
  },
  {
    org: "The Art of Living",
    role: "Assistant Legal Advisor",
    period: "2015 — 2016",
    points: [
      "Real Estate Documentation",
      "Land Due Diligence",
      "Contract Negotiation",
      "World Culture Festival",
      "Corporate Legal Support",
    ],
  },
];

export const EDUCATION = [
  {
    degree: "LL.M.",
    school: "National Academy of Legal Studies & Research (NALSAR), Hyderabad",
    stream: "Public Law & Legal Theory",
    period: "2016 — 2017",
  },
  {
    degree: "B.A. LL.B. (Hons.)",
    school: "Nirma University",
    stream: "",
    period: "2010 — 2015",
  },
];

export const CERTIFICATIONS = ["Intellectual Property Rights", "Technology Laws"];

export const PUBLICATIONS = [
  {
    title: "Secondary Victimization of Women in Rape Cases",
    kind: "Legal Research Paper",
  },
  {
    title: "Sentencing in Rape Cases in India",
    kind: "Legal Research Paper",
  },
  {
    title: "Clinical Trials: Shocking Violation of Human Rights",
    kind: "Legal Research Paper",
  },
  {
    title: "Govindachamy vs State of Kerala",
    kind: "Case Commentary",
  },
];

export const WHY_CHOOSE = [
  "Practical Legal Advice",
  "Real Estate Expertise",
  "Strong Documentation Skills",
  "Detail-Oriented Approach",
  "Technology Law Experience",
  "Ethical & Transparent Practice",
  "Client-Focused Solutions",
  "Business-Oriented Legal Thinking",
];

export const FAQS = [
  {
    q: "What legal services do you offer?",
    a: "Real estate consultancy, due diligence, contract drafting and review, legal advisory, and litigation support — with particular depth in property, corporate, and technology matters.",
  },
  {
    q: "Can you review my property documents before purchase?",
    a: "Yes. A pre-purchase review typically covers title, ownership chain, encumbrances, approvals, and any regulatory exposure before you commit funds.",
  },
  {
    q: "Do you provide legal due diligence for land?",
    a: "Yes. Land due diligence engagements include title investigation, ownership verification, encumbrance review, and a written risk assessment tailored to the transaction.",
  },
  {
    q: "Can you draft customized legal agreements?",
    a: "Yes — from sale deeds, leases, and MOUs to SaaS, API, franchise, and commercial agreements. Every draft is prepared for your specific commercial context.",
  },
  {
    q: "Do you advise startups and businesses?",
    a: "Yes. Founders and growing companies are advised on contracts, technology-law documentation, and day-to-day legal risk without the overhead of a full retainer.",
  },
  {
    q: "How do I schedule a consultation?",
    a: "Use the contact form or the Book a Consultation button. You will receive a response within one business day to confirm timing.",
  },
];
